var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Special implementation of Error for when there is a failed fetch (API or normal)
 */
var FetchError = /** @class */ (function (_super) {
    __extends(FetchError, _super);
    function FetchError(errorMessage, status, responseData, responseHeaders, axiosErrorCode, errorTranslationKey) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, errorMessage) || this;
        _this.status = status;
        _this.responseData = responseData;
        _this.responseHeaders = responseHeaders;
        _this.axiosErrorCode = axiosErrorCode;
        _this.errorTranslationKey = errorTranslationKey;
        // Error breaks the prototype chain, so restore it manually. See:
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return FetchError;
}(Error));
export { FetchError };
/**
 * Special implementation of Error for when there is a timeout
 */
var TimeoutError = /** @class */ (function (_super) {
    __extends(TimeoutError, _super);
    function TimeoutError(errorMessage) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, errorMessage) || this;
        // Error breaks the prototype chain, so restore it manually. See:
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return TimeoutError;
}(Error));
export { TimeoutError };
/**
 * Error class to indicate a missing credential
 */
var MissingCredentialError = /** @class */ (function (_super) {
    __extends(MissingCredentialError, _super);
    function MissingCredentialError(credentialId) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, "The provided credential ID \"".concat(credentialId || 'undefined', "\" is not available to the current user.")) || this;
        // Error breaks the prototype chain, so restore it manually. See:
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return MissingCredentialError;
}(Error));
export { MissingCredentialError };
export var USER_ERROR_CONTEXTS = Object.freeze({
    ACCOUNT: 'account selector',
    PLUGIN: 'plugin selector',
    EXTENSION: 'extension selector',
});
/**
 * Error class to indicate a user cancellation
 */
var UserCancelError = /** @class */ (function (_super) {
    __extends(UserCancelError, _super);
    function UserCancelError(selectorType) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, "Selection canceled: ".concat(selectorType)) || this;
        _this.name = 'UserCancelError';
        // Error breaks the prototype chain, so restore it manually. See:
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return UserCancelError;
}(Error));
export { UserCancelError };
/**
 * Error class to indicate a user went back
 */
var UserBackError = /** @class */ (function (_super) {
    __extends(UserBackError, _super);
    function UserBackError(selectorType) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, "The user backed out of the ".concat(selectorType)) || this;
        _this.name = 'UserBackError';
        // Error breaks the prototype chain, so restore it manually. See:
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return UserBackError;
}(Error));
export { UserBackError };
/**
 * Error class to indicate wrong scheme
 */
var WrongSchemeError = /** @class */ (function (_super) {
    __extends(WrongSchemeError, _super);
    function WrongSchemeError(scheme) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, "This function require scheme: ".concat(scheme)) || this;
        _this.name = 'WrongSchemeError';
        // Error breaks the prototype chain, so restore it manually. See:
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return WrongSchemeError;
}(Error));
export { WrongSchemeError };
/**
 * Representation of an error from Egress Gateway, which takes the following form:
 * {
 *    meta: ...
 *    error: {
 *      errorCode: "ERR_X.X"
 *      errorMessage: "message"
 *    }
 * }
 */
var EgressServiceError = /** @class */ (function (_super) {
    __extends(EgressServiceError, _super);
    function EgressServiceError(errorCode, errorMessage) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, errorMessage) || this;
        _this.errorCode = errorCode;
        // Error breaks the prototype chain, so restore it manually. See:
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return EgressServiceError;
}(Error));
export { EgressServiceError };
/**
 * Represents error thrown when a (successful) EgressResponse does not
 * match the expected response.
 */
var EgressUnexpectedResponseError = /** @class */ (function (_super) {
    __extends(EgressUnexpectedResponseError, _super);
    function EgressUnexpectedResponseError(httpStatusCode, errorMessage) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, errorMessage) || this;
        _this.httpStatusCode = httpStatusCode;
        // Error breaks the prototype chain, so restore it manually. See:
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return EgressUnexpectedResponseError;
}(Error));
export { EgressUnexpectedResponseError };
/**
 * Special implementation of Error for when thre is an inssue with OAuth credentials creation
 */
var OCSError = /** @class */ (function (_super) {
    __extends(OCSError, _super);
    function OCSError(errorMessage, error) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, errorMessage) || this;
        _this.error = error;
        // Error breaks the prototype chain, so restore it manually. See:
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return OCSError;
}(Error));
export { OCSError };
//# sourceMappingURL=errorTypes.js.map